// Nuevo archivo: D:\directiveai-react\frontend\src\components\AGTPromo\testimonialData.js

// Testimonios para cada sección de AGT
export const testimonialData = [
    // AGT Pro testimonios
    {
      section: 'pro',
      text: "AGT Pro transformed how I work. The unlimited conversations and faster responses have made my daily tasks so much more efficient.",
      author: "Michael R.",
      gradientColors: "#415B7E, #2D476A, #193356"
    },
    {
      section: 'pro',
      text: "The visual recognition feature is incredible. I just show AGT what I'm looking at and get instant insights.",
      author: "Sarah T.",
      gradientColors: "#415B7E, #2D476A, #193356"
    },
    {
      section: 'pro',
      text: "Being able to integrate documents and images has streamlined my workflow completely. I'm saving hours every week.",
      author: "David K.",
      gradientColors: "#415B7E, #2D476A, #193356"
    },
    {
      section: 'pro',
      text: "Voice messages with transcriptions are a game-changer for me. I can communicate on the go and review everything later.",
      author: "Jennifer P.",
      gradientColors: "#415B7E, #2D476A, #193356"
    },
    {
      section: 'pro',
      text: "The A1 reasoning engine gives me insights I wouldn't have thought of. It's like having a brilliant assistant 24/7.",
      author: "Robert M.",
      gradientColors: "#415B7E, #2D476A, #193356"
    },
    {
      section: 'pro',
      text: "I love being first to experience new features. AGT Pro keeps getting better every month.",
      author: "Emma S.",
      gradientColors: "#415B7E, #2D476A, #193356"
    },
    {
      section: 'pro',
      text: "Creating multiple projects with expanded capabilities has helped me organize my work like never before.",
      author: "Thomas L.",
      gradientColors: "#415B7E, #2D476A, #193356"
    },
    {
      section: 'pro',
      text: "The Ultra reasoning engine understands complex requests that other AI systems struggle with. Worth every penny.",
      author: "Lisa W.",
      gradientColors: "#415B7E, #2D476A, #193356"
    },
  
    // AGT Edu testimonios
    {
      section: 'edu',
      text: "AGT Edu helped me raise my GPA from 3.2 to 3.8 in just one semester. The practice exams are incredibly effective.",
      author: "Alex J., Student",
      gradientColors: "#25505A, #113C46"
    },
    {
      section: 'edu',
      text: "The research feature with sources has been invaluable for my thesis. It finds relevant information I would have missed.",
      author: "Maria C., Graduate Student",
      gradientColors: "#25505A, #113C46"
    },
    {
      section: 'edu',
      text: "As a professor, I use AGT Edu to create better course materials. My students' engagement has improved dramatically.",
      author: "Dr. Williams, Professor",
      gradientColors: "#25505A, #113C46"
    },
    {
      section: 'edu',
      text: "The automatic citation generation saves me hours on research papers. No more formatting headaches!",
      author: "James H., Ph.D. Candidate",
      gradientColors: "#25505A, #113C46"
    },
    {
      section: 'edu',
      text: "I uploaded all my courses and AGT recommended a perfect study plan. My exam anxiety is gone.",
      author: "Sophia R., Undergrad",
      gradientColors: "#25505A, #113C46"
    },
    {
      section: 'edu',
      text: "The Microsoft Office integration means I never have to switch between applications. It's all seamless.",
      author: "Daniel T., MBA Student",
      gradientColors: "#25505A, #113C46"
    },
    {
      section: 'edu',
      text: "My daughter was struggling in calculus. AGT Edu helped her understand concepts her teacher couldn't explain clearly.",
      author: "Karen M., Parent",
      gradientColors: "#25505A, #113C46"
    },
    {
      section: 'edu',
      text: "Our school district implemented AGT Edu last year. Test scores have improved by 23% across all subjects.",
      author: "Principal Johnson",
      gradientColors: "#25505A, #113C46"
    },
  
    // AGT Ups testimonios
    {
      section: 'ups',
      text: "AGT Ups helped me optimize our pricing strategy, resulting in a 32% increase in profit margin within three months.",
      author: "Natalie R., CEO",
      gradientColors: "#DC9844, #C88430, #B4701C"
    },
    {
      section: 'ups',
      text: "The supplier negotiation assistance saved us $50,000 on our first major order. The ROI is incredible.",
      author: "Marcus T., Procurement Manager",
      gradientColors: "#DC9844, #C88430, #B4701C"
    },
    {
      section: 'ups',
      text: "Automating our financial updates with receipt scanning has cut our bookkeeping time by 70%. Game changer.",
      author: "Olivia P., Small Business Owner",
      gradientColors: "#DC9844, #C88430, #B4701C"
    },
    {
      section: 'ups',
      text: "The expert advice for complex decisions helped us pivot during a crisis. Our company might not have survived without it.",
      author: "Chris L., Startup Founder",
      gradientColors: "#DC9844, #C88430, #B4701C"
    },
    {
      section: 'ups',
      text: "The tailored strategies for each stage of our growth have been spot on. It's like having a team of consultants on demand.",
      author: "Samantha K., COO",
      gradientColors: "#DC9844, #C88430, #B4701C"
    },
    {
      section: 'ups',
      text: "We increased sales by 47% after implementing AGT Ups' market fit recommendations. Worth every penny.",
      author: "Victor M., Sales Director",
      gradientColors: "#DC9844, #C88430, #B4701C"
    },
    {
      section: 'ups',
      text: "The productivity shortcuts have transformed our team's efficiency. We're accomplishing more with fewer resources.",
      author: "Elena J., Operations Manager",
      gradientColors: "#DC9844, #C88430, #B4701C"
    },
    {
      section: 'ups',
      text: "From idea to profitable business in 6 months with AGT Ups guiding our strategy. Best investment we made.",
      author: "Ryan D., Entrepreneur",
      gradientColors: "#DC9844, #C88430, #B4701C"
    },
  
    // AGT Job testimonios
    {
      section: 'job',
      text: "My resume was getting no responses for months. AGT Job rewrote it, and I had three interviews within a week.",
      author: "Brandon T., Software Engineer",
      gradientColors: "#4A4A4A, #333333, #1A1A1A"
    },
    {
      section: 'job',
      text: "The interview practice feature prepared me for questions I never expected. I felt so confident and got the job!",
      author: "Melissa C., Marketing Specialist",
      gradientColors: "#4A4A4A, #333333, #1A1A1A"
    },
    {
      section: 'job',
      text: "After optimizing my LinkedIn profile with AGT Job, recruiters started contacting me regularly. It was like flipping a switch.",
      author: "Jason P., Project Manager",
      gradientColors: "#4A4A4A, #333333, #1A1A1A"
    },
    {
      section: 'job',
      text: "The salary negotiation strategies helped me secure a 15% higher offer than I initially expected to accept.",
      author: "Aisha R., Financial Analyst",
      gradientColors: "#4A4A4A, #333333, #1A1A1A"
    },
    {
      section: 'job',
      text: "I was changing careers and had no relevant experience. AGT Job showed me how to highlight transferable skills effectively.",
      author: "Michael S., Career Changer",
      gradientColors: "#4A4A4A, #333333, #1A1A1A"
    },
    {
      section: 'job',
      text: "The job market trend analysis helped me focus on skills that are actually in demand, not what I thought employers wanted.",
      author: "Rachel D., UX Designer",
      gradientColors: "#4A4A4A, #333333, #1A1A1A"
    },
    {
      section: 'job',
      text: "After being laid off, AGT Job helped me land a better position in just 3 weeks. It reduced my stress immensely.",
      author: "Kevin L., Sales Manager",
      gradientColors: "#4A4A4A, #333333, #1A1A1A"
    },
    {
      section: 'job',
      text: "The networking strategies transformed my approach. I'm connecting with decision-makers instead of applying blindly.",
      author: "Tanya W., Consultant",
      gradientColors: "#4A4A4A, #333333, #1A1A1A"
    },
  
    // AGT Fit testimonios
    {
      section: 'fit',
      text: "I've tried many fitness apps, but AGT Fit is the first one that truly understands my goals and adjusts as I progress.",
      author: "Jordan M., Fitness Enthusiast",
      gradientColors: "#FF8C00, #FF6B00, #FF5722"
    },
    {
      section: 'fit',
      text: "The form correction feature is incredible. It's like having a personal trainer watching every rep.",
      author: "Alicia T., CrossFit Athlete",
      gradientColors: "#FF8C00, #FF6B00, #FF5722"
    },
    {
      section: 'fit',
      text: "I've lost 28 pounds in 4 months following AGT Fit's personalized nutrition plan. It doesn't feel like a diet at all.",
      author: "Derek P., Weight Loss Journey",
      gradientColors: "#FF8C00, #FF6B00, #FF5722"
    },
    {
      section: 'fit',
      text: "The analytics help me see progress I wouldn't otherwise notice. It keeps me motivated when the scale doesn't move.",
      author: "Stephanie L., Marathon Runner",
      gradientColors: "#FF8C00, #FF6B00, #FF5722"
    },
    {
      section: 'fit',
      text: "The community challenges push me to new levels. I'm accomplishing fitness goals I never thought possible.",
      author: "Marcus J., Bodybuilder",
      gradientColors: "#FF8C00, #FF6B00, #FF5722"
    },
    {
      section: 'fit',
      text: "At 62, I thought my fitness days were behind me. AGT Fit created a program perfect for my age and limitations.",
      author: "Barbara K., Senior Fitness",
      gradientColors: "#FF8C00, #FF6B00, #FF5722"
    },
    {
      section: 'fit',
      text: "The mindfulness sessions have improved my recovery time and reduced injuries. It's a complete wellness approach.",
      author: "Tyler R., Sports Therapist",
      gradientColors: "#FF8C00, #FF6B00, #FF5722"
    },
    {
      section: 'fit',
      text: "My Apple Watch integration means all my workouts sync automatically. The convenience keeps me consistent.",
      author: "Vanessa M., Busy Professional",
      gradientColors: "#FF8C00, #FF6B00, #FF5722"
    },
  
    // AGT Health testimonios
    {
      section: 'health',
      text: "AGT Health+ helped me understand my chronic condition better than years of Googling symptoms ever did.",
      author: "Patricia L., Patient",
      gradientColors: "#4CAF50, #3d8b40, #2e7031"
    },
    {
      section: 'health',
      text: "The medication reminder system has improved my adherence from 60% to 98%. My doctor is amazed at my progress.",
      author: "Robert C., Managing Diabetes",
      gradientColors: "#4CAF50, #3d8b40, #2e7031"
    },
    {
      section: 'health',
      text: "As a parent of three, the family health management has been a lifesaver for keeping track of vaccinations and checkups.",
      author: "Jessica T., Mom",
      gradientColors: "#4CAF50, #3d8b40, #2e7031"
    },
    {
      section: 'health',
      text: "I used the doctor visit preparation checklist and finally got answers after years of being dismissed by physicians.",
      author: "Andrew S., Chronic Pain Sufferer",
      gradientColors: "#4CAF50, #3d8b40, #2e7031"
    },
    {
      section: 'health',
      text: "The preventive care alerts caught a potential issue early. My doctor said it might have saved my life.",
      author: "Margaret W., Early Detection",
      gradientColors: "#4CAF50, #3d8b40, #2e7031"
    },
    {
      section: 'health',
      text: "Managing my elderly mother's health records was overwhelming until AGT Health+. Now everything is organized and accessible.",
      author: "David P., Caregiver",
      gradientColors: "#4CAF50, #3d8b40, #2e7031"
    },
    {
      section: 'health',
      text: "The symptom analysis helped me communicate more effectively with my doctor, leading to a correct diagnosis.",
      author: "Sophia J., Rare Condition",
      gradientColors: "#4CAF50, #3d8b40, #2e7031"
    },
    {
      section: 'health',
      text: "As someone with multiple health conditions, tracking everything was impossible before. AGT Health+ simplifies my complex care.",
      author: "Thomas R., Complex Health Needs",
      gradientColors: "#4CAF50, #3d8b40, #2e7031"
    },
  
    // AGT Legal testimonios
    {
      section: 'legal',
      text: "AGT Legal helped me understand my lease before signing. It identified clauses that would have cost me thousands.",
      author: "Brian K., Tenant",
      gradientColors: "#2C5282, #234876, #1A365D"
    },
    {
      section: 'legal',
      text: "Starting my small business was daunting, but AGT Legal generated all the documents I needed with clear explanations.",
      author: "Michelle P., Entrepreneur",
      gradientColors: "#2C5282, #234876, #1A365D"
    },
    {
      section: 'legal',
      text: "During my divorce, AGT Legal helped me prepare for meetings with my attorney, saving me hours of billable time.",
      author: "Steven M., Divorce Proceedings",
      gradientColors: "#2C5282, #234876, #1A365D"
    },
    {
      section: 'legal',
      text: "The contract review saved our company from agreeing to unfavorable terms that were buried in legal jargon.",
      author: "Laura T., Business Owner",
      gradientColors: "#2C5282, #234876, #1A365D"
    },
    {
      section: 'legal',
      text: "I needed to understand local regulations for my home renovation. AGT Legal explained everything clearly and saved me from violations.",
      author: "Carlos R., Homeowner",
      gradientColors: "#2C5282, #234876, #1A365D"
    },
    {
      section: 'legal',
      text: "When disputing a credit card charge, AGT Legal guided me through the process and I won the case easily.",
      author: "Jennifer S., Consumer",
      gradientColors: "#2C5282, #234876, #1A365D"
    },
    {
      section: 'legal',
      text: "Creating a comprehensive will seemed overwhelming until AGT Legal broke it down into simple steps.",
      author: "William D., Estate Planning",
      gradientColors: "#2C5282, #234876, #1A365D"
    },
    {
      section: 'legal',
      text: "As a landlord, AGT Legal helps me stay compliant with constantly changing rental regulations in multiple cities.",
      author: "Gregory H., Property Manager",
      gradientColors: "#2C5282, #234876, #1A365D"
    },
  
    // AGT Translate testimonios
    {
      section: 'translate',
      text: "AGT Translate helped me communicate with my in-laws who don't speak English. It's brought our family closer together.",
      author: "Amanda L., Multilingual Family",
      gradientColors: "#3498DB, #5D6FBD, #9B59B6"
    },
    {
      section: 'translate',
      text: "I travel internationally for business, and the offline mode has been essential in countries with limited connectivity.",
      author: "Richard T., Business Traveler",
      gradientColors: "#3498DB, #5D6FBD, #9B59B6"
    },
    {
      section: 'translate',
      text: "The document translation preserves all formatting perfectly. It saved our team weeks of manual reformatting work.",
      author: "Julia M., Project Manager",
      gradientColors: "#3498DB, #5D6FBD, #9B59B6"
    },
    {
      section: 'translate',
      text: "I'm learning Japanese, and the personalized lessons adapt to my specific mistakes and learning style.",
      author: "Nathan P., Language Student",
      gradientColors: "#3498DB, #5D6FBD, #9B59B6"
    },
    {
      section: 'translate',
      text: "The image translation feature helped me navigate menus and street signs during my vacation in Thailand.",
      author: "Emily S., Tourist",
      gradientColors: "#3498DB, #5D6FBD, #9B59B6"
    },
    {
      section: 'translate',
      text: "Our company expanded to international markets, and AGT Translate ensures our communications are culturally appropriate.",
      author: "Victor C., International Business",
      gradientColors: "#3498DB, #5D6FBD, #9B59B6"
    },
    {
      section: 'translate',
      text: "The real-time conversation feature let me have a meaningful discussion with my grandmother for the first time.",
      author: "Sophia L., Connecting Generations",
      gradientColors: "#3498DB, #5D6FBD, #9B59B6"
    },
    {
      section: 'translate',
      text: "As a teacher with ESL students, AGT Translate bridges communication gaps and helps me support all my students equally.",
      author: "Mark J., Educator",
      gradientColors: "#3498DB, #5D6FBD, #9B59B6"
    }
  ];